export interface VendorOption {
  id: number
  name: string
}

/** Keeps known historical vendor IDs editable even when a lookup response is incomplete. */
export function vendorPaymentOptions(
  selectableVendors: readonly VendorOption[],
  historicalVendorIds: readonly number[],
  historicalVendorNames: Record<string, string>,
): VendorOption[] {
  const vendors = new Map(selectableVendors.map((vendor) => [vendor.id, vendor.name]))
  for (const vendorId of historicalVendorIds) {
    if (!vendors.has(vendorId)) vendors.set(vendorId, historicalVendorNames[String(vendorId)] ?? `Vendor ${vendorId}`)
  }
  return [...vendors.entries()]
    .map(([id, name]) => ({ id, name }))
    .sort((left, right) => left.name.localeCompare(right.name) || left.id - right.id)
}
